import React from 'react';

type EventBus = unknown;


const ViewerContext = React.createContext<{
    eventBus: EventBus,
} | undefined>(undefined);

export default ViewerContext;